<div>
  {#if value}
    {#each value as item (item.id)}
      <div class="field">
        <div class="wrap-item">
          <Inputitem bind:value={value[item.id].field} />
          <a on:click={() => removeitem(item.id)} class="close">❌</a>
        </div>
        <div>
          {#if value[item.id].field === 'data'}
            <div>
              <Dataitem bind:value={value[item.id].type} />
            </div>
          {/if}
          {#if value[item.id].value &&
            value[item.id].field === 'data'}
            <div class="wrap">
              {#if value[item.id].field}
                <span>Label:</span> <input bind:value={value[item.id].label} />
              {/if}
            </div>
          {/if}
          {#if value[item.id].value &&
            value[item.id].field === 'data' &&
            value[item.id]['value']['type'] === 'csv'}
            <div class="wrap">
              <span>Items:</span> <textarea bind:value={value[item.id]['value'].items} />
            </div>
            <div class="wrap column">
              <h4>Have dataset and csv file handy?</h4>
              <span>File:</span> <input type="file" bind:files>
              <span>
                {#if files}
                	<h2>Selected files:</h2>
                	{#each Array.from(files) as file}
                		<p>{file.name} ({file.size} bytes) </p>
                	{/each}
                  {#await filecontent then data}
                    <span>{setValue(item.id,data)}</span>
                  {/await}
                {/if}
              </span>
            </div>
          {/if}
          {#if value[item.id].value &&
            value[item.id].field === 'data' &&
            value[item.id]['value']['type'] === 'freesurfer'}
            <div class="wrap column">
              <div class="wrap nobottom">
                <span>Items:</span> <DataTypeitem bind:value={value[item.id]['value'].items} />
              </div>
              <div>
                <div class="note">You can select either "Freesurfer" or "NiFTI"</div>
              </div>
            </div>
            <div class="wrap">
              <span>Extensions:</span> <textarea bind:value={value[item.id]['value'].extensions} />
            </div>
          {/if}
        </div>
        {#if value[item.id].field && value[item.id].field !== 'data'}
          <div class="wrap">
            {#if value[item.id].field}
              <span>Label:</span> <input bind:value={value[item.id].label} />
            {/if}
          </div>
          {#if value[item.id].value && value[item.id].field === 'boolean'}
            <div class="wrap">
              <div class="wrap">
                <span>Default:</span>
                <Switch on:change={(e) => handleBoolean(e,item.id)} checked={value[item.id].default} />
              </div>
              <div class="wrap">
                <span>Owner:</span>
                <Switch on:change={(e) => handleSource(e,item.id)} checked={value[item.id].owner} />
             </div>
           </div>
          {/if}

          {#if value[item.id].value && value[item.id].field === 'number'}
            <div class="wrap">
              <span>Default:</span> <input type="number" bind:value={value[item.id]['value'].default} />
            </div>
            <div class="wrap">
              <span>Owner:</span>
              <Switch on:change={(e) => handleSource(e,item.id)} checked={value[item.id].owner} />
           </div>
          {/if}

          {#if value[item.id].value && value[item.id].field === 'range'}
            <div class="wrap">
              <span>Default:</span> <input type="number" bind:value={value[item.id]['value'].default} />
            </div>
            <div class="wrap">
              <span>Min:</span> <input type="number" bind:value={value[item.id]['value'].min} />
            </div>
            <div class="wrap">
              <span>Max:</span> <input type="number" bind:value={value[item.id]['value'].max} />
            </div>
            <div class="wrap">
              <span>Step:</span> <input type="number" bind:value={value[item.id]['value'].step} />
            </div>
            <div class="wrap">
              <span>Owner:</span>
              <Switch on:change={(e) => handleSource(e,item.id)} checked={value[item.id].owner} />
           </div>
          {/if}

          {#if value[item.id].value && value[item.id].field === 'string'}
            <div class="wrap">
              <span>Default:</span> <input bind:value={value[item.id]['value'].default} />
            </div>
            <div class="wrap">
              <span>Owner:</span>
              <Switch on:change={(e) => handleSource(e,item.id)} checked={value[item.id].owner} />
           </div>
          {/if}

          {#if value[item.id].value && value[item.id].field === 'object'}
            <div class="wrap">
              <span>Default:</span> <textarea bind:value={value[item.id]['value'].default} />
            </div>
            <div class="wrap">
              <span>Owner:</span>
              <Switch on:change={(e) => handleSource(e,item.id)} checked={value[item.id].owner} />
           </div>
          {/if}

          {#if value[item.id].value && value[item.id].field === 'select'}
            <div class="wrap">
              <span>Default:</span> <textarea bind:value={value[item.id]['value'].default} />
            </div>
            <div class="wrap">
              <span>Owner:</span>
              <Switch on:change={(e) => handleSource(e,item.id)} checked={value[item.id].owner} />
           </div>
          {/if}

        {/if}
      </div>
    {/each}
  {/if}
  <a on:click={addItem}>+ Add Field</a>
</div>

<script>
  import Switch from "svelte-switch";
  import Inputitem from './InputSelect.svelte';
  import Dataitem from './DataSelect.svelte';
  import DataTypeitem from './DataTypeSelect.svelte';

	import {
		beautifyJSON
	} from './helpers.js';

  export let value;

  let files;
  $: files = files;

  $: filecontent = readCSVFile(files).then((value) => { return value });

  const setValue = ((id, val) => {
    if(val){
      if(value[id]['value']['data'] == undefined){
        value[id]['value']['data'] = val;
      }
    }
  });

  const csvToArray = (str, delimiter = ",") => {

    let headers = str.slice(0, str.indexOf("\n")).split(delimiter);

    let rows = str.slice(str.indexOf("\n") + 1).split("\n");

    let arr = rows.map(function (row) {
      let values = row.split(delimiter);
      let el = headers.reduce(function (object, header, index) {
        object[header] = values[index];
        return object;
      }, {});
      return el;
    });

    return arr;
  }

  const csvToInputObj = (arr) => {
    let obj = {};
    for( let item in arr ){
      let key = arr[item]['freesurferfile'];
      if(key){
        obj[`"${key}"`] = { '"age"':arr[item]['age'], '"isControl"':arr[item]['isControl'] };
      }
    }
    return obj;
  }

  const readCSVFile = async (files) => {
    if(files) {
      let file = files[0];
      let text = await file.text();
      return csvToInputObj(csvToArray(text));
    }
  }

	let itemId = 0;

	const fields = [
		{value: 'data', label: 'Data'},
		{value: 'string', label: 'String'},
		{value: 'number', label: 'Number'},
		{value: 'object', label: 'Object'},
		{value: 'boolean', label: 'Boolean'},
	];

	export const addItem = (() => {
		value = [...value, {id: itemId, field: null}];
		itemId += 1;
	});

	export const removeitem = ((id) => {
		value = [...value.filter(item => item.id != id)];
		itemId = value.length;
	});

	export const handleBoolean = ((e, id) => {
    value[id]['value'].default = e.detail.checked;
    value[id].defua = e.detail.checked;
	});

	export const handleSource = ((e, id) => {
		value[id]['value'].source = e.detail.checked ? 'owner' : 'member';
		value[id].owner = e.detail.checked;
	});

</script>

<style>
	.field {
		border-bottom: 5px solid white;
	}
	.wrap-item {
		display: flex;
		justify-content: space-around;
		align-items: center;
		background: #efefef;
	}
	.wrap-item a {
		padding: 0 1rem 0 0;
	}
	.wrap {
	  padding: 1rem;
		background: #efefef;
		display: flex;
		justify-content: flex-start;
		align-items: baseline;
	}
  .wrap.column {
    flex-direction: column;
	}
	.wrap > .wrap {
		padding: 0;
		margin-right: 1rem;
	}
	.wrap span {
		display: inline-block;
		margin-right: 0.5rem;
	}
	.close {
		margin: 0;
	}
	input, textarea {
		width: 100%;
	}
	.results {
		width: 100%;
		min-height: 80vh;
		font-size: 0.75rem;
	}
</style>
